import { StyledSite } from './styles';

const PageWrapper = ({ children }) => <StyledSite>{children}</StyledSite>;

export default PageWrapper;
